var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F9FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.2667 43.9144C61.4202 43.9144 60.2989 43.8956 58.9028 43.8956C55.4981 43.8956 52.6986 41.0775 52.6986 37.6406V31.6106C52.6986 31.1362 52.3181 30.75 51.8484 30.75H41.9313C37.3051 30.75 33.5625 34.5487 33.5625 39.2044V59.4075C33.5625 64.2919 37.4833 68.25 42.3193 68.25H57.0854C61.6986 68.25 65.4375 64.4756 65.4375 59.8162V44.7581C65.4375 44.2819 65.0588 43.8975 64.5873 43.8994C63.7946 43.905 62.8441 43.9144 62.2667 43.9144Z",
    fill: "#4286F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M57.1575 31.8137C56.5988 31.2306 55.6181 31.6318 55.6181 32.4399V37.3843C55.6181 39.4581 57.3263 41.1643 59.4 41.1643C60.7069 41.1793 62.5219 41.1831 64.0631 41.1793C64.8525 41.1774 65.2538 40.2343 64.7063 39.6643C62.7281 37.6074 59.1863 33.9212 57.1575 31.8137Z",
    fill: "#4286F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2531 51.3474L53.5425 49.0562C54.0881 48.5124 54.0881 47.6293 53.5425 47.0837C52.9969 46.538 52.1138 46.538 51.5681 47.0837L49.2788 49.3712L46.9894 47.0837C46.4438 46.538 45.5588 46.538 45.0131 47.0837C44.4675 47.6293 44.4675 48.5124 45.0131 49.0562L47.3044 51.3474L45.0131 53.6368C44.4675 54.1824 44.4675 55.0655 45.0131 55.6093C45.2869 55.883 45.6431 56.0199 46.0013 56.0199C46.3594 56.0199 46.7156 55.883 46.9894 55.6093L49.2788 53.3218L51.5681 55.6093C51.84 55.883 52.1981 56.0199 52.5563 56.0199C52.9125 56.0199 53.2706 55.883 53.5425 55.6093C54.0881 55.0655 54.0881 54.1824 53.5425 53.6368L51.2531 51.3474Z",
    fill: "#4286F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/No-Found.52ffdf7384f8a1e2cb33fb41bce10b3e.svg";
export { ForwardRef as ReactComponent };